import { useEffect, useState } from "react";
import { Card, Form } from "react-bootstrap";
import ReactApexChart from "react-apexcharts";
import { useDispatch, useSelector } from "react-redux";
import { Skeleton } from "@mui/material";
import { StatusCode } from "../services/helper";
import { fetchRegisteredKitData } from "../redux/slice/DashboardListingSlice";

const periods = [
  {
    label: "Last 30 Days",
    value: "last_30_days",
  },
  {
    label: "Last 90 Days",
    value: "last_90_days",
  },
  {
    label: "Last 6 Months",
    value: "last_6_months",
  },
  {
    label: "Current Year",
    value: "year_to_date",
  },
];

const CardWithLineChart = ({ style, className }) => {
  const dispatch = useDispatch();
  const [period, setPeriod] = useState("year_to_date");
  const { registeredKitData, registeredKitStatus } = useSelector(
    (state) => state.DASHBOARDLISTING
  );
  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(fetchRegisteredKitData(period));
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      }
    };

    fetchData();
  }, [dispatch, period]);

  const [activeData, setActiveData] = useState({
    series: [
      {
        name: "Total Kits",
        data: [],
      },
    ],
    options: {
      chart: {
        height: 350,
        type: "line",
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        colors: ["#006AFF"],
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "light",
          type: "vertical",
          gradientFromColors: ["rgba(0, 106, 255, 0.25)"],
          gradientToColors: ["rgba(31, 125, 255, 0)"],
          inverseColors: false,
          opacityFrom: 0.6,
          opacityTo: 0.2,
          stops: [0, 100],
        },
      },
      // title: {
      //   text: "Product Trends by Month",
      //   align: "left",
      // },
      grid: {
        row: {
          colors: ["transparent"],
        },
        borderColor: "#A8A8BD",
        strokeDashArray: 4,
      },
      xaxis: {
        categories: [],
        labels: {
          style: {
            colors: "#A8A8BD",
            fontSize: "14px",
          },
        },
      },
      yaxis: {
        labels: {
          style: {
            colors: "#A8A8BD",
            fontSize: "14px",
          },
        },
      },
      markers: {
        size: 0,
        strokeWidth: 5,
        strokeColors: "#FFFFFF",
        colors: ["#006AFF"],
        hover: {
          size: 8,
          sizeOffset: 2,
        },
      },
      tooltip: {
        custom: function ({ series, seriesIndex, dataPointIndex }) {
          const title = "Total Customer";
          const value = series[seriesIndex][dataPointIndex];
          return `
            <div style="background: #ffffff; padding: 10px; border-radius: 5px;display:flex;flex-direction:column;row-gap:10px;box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1)">
              <div style="font-size: 12px; color: #A8A8BD; font-weight: 400;">${title}</div>
              <div style="font-size: 16px; color: #16161D; font-weight: bold;">${value}</div>
            </div>
          `;
        },
      },
    },
  });

  useEffect(() => {
    const xAxisData = Object.keys(registeredKitData);
    const yAxisData = Object.values(registeredKitData);

    setActiveData((prev) => ({
      ...prev,
      series: [
        {
          name: "Registered Kits",
          data: yAxisData,
        },
      ],
      options: {
        ...prev.options,
        xaxis: {
          ...prev.options.xaxis,
          categories: xAxisData,
        },
      },
    }));
  }, [registeredKitData]);

  const handlePeriod = (e) => {
    const { value } = e.target;
    setPeriod(value);
  };

  if (registeredKitStatus === StatusCode.LOADING) {
    return (
      <Card className="dashboard_cards h-100" style={{ border: "none" }}>
        <Card.Body className="d-flex flex-column gap-3">
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
            <Card.Title
              style={{
                fontSize: style?.fontSize,
                fontWeight: style?.fontWeight,
              }}
              className={`m-0 text_gray ${className}`}
            >
              Registered Kits
            </Card.Title>
            <Skeleton width={150} height={50} sx={{ transform: "none" }} />
          </div>
          <Skeleton height={75} />
          <Skeleton height={75} />
          <Skeleton height={75} />
          <Skeleton height={75} />
        </Card.Body>
      </Card>
    );
  } else {
    return (
      <Card className="dashboard_cards h-100" style={{ border: "none" }}>
        <Card.Body className="d-flex flex-column gap-3">
          <div className="d-flex justify-content-between flex-wrap gap-3 align-items-center">
            <Card.Title
              style={{
                fontSize: style?.fontSize,
                fontWeight: style?.fontWeight,
              }}
              className={`m-0 text_gray ${className}`}
            >
              Registered Kits
            </Card.Title>
            <Form.Select
              placeholder="Select a period"
              value={period}
              onChange={handlePeriod}
              className="w-auto text_gray"
            >
              <option value="" disabled className="option-title">
                Select a period
              </option>
              {periods.map((option) => (
                <option
                  key={option.value}
                  value={option.value}
                  className="text_gray"
                >
                  {option.label}
                </option>
              ))}
            </Form.Select>
          </div>
          <div id="chart">
            <ReactApexChart
              key={JSON.stringify(activeData)}
              options={activeData.options}
              series={activeData.series}
              type="area"
              height={350}
            />
            <div id="html-dist" />
          </div>
        </Card.Body>
      </Card>
    );
  }
};

export default CardWithLineChart;
